import { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Combo from "../../assets/img/combo.webp";
import "./ModalAward.css";
import { Link } from "react-router-dom";
export default function ModalAward() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (Combo) {
      setShow(true)
    }
  }, [Combo]);

  const handleClose = () => setShow(false);
  return (
    <>

      <Modal show={show} onHide={handleClose} centered className={`award-modal ${show ? "show" : "hide"}`}>
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <Link to={"/ct/perfume"}>
            <img
              width={1500}
              height={1000}
              src={Combo} className="img-fluid" alt="combo popup" />
          </Link>
        </Modal.Body>
      </Modal>
    </>
  );
}
